import { MaterialCreateRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const createRoute = {
  path: 'create',
  element: <MaterialCreateRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Create</span>,
  }),
};